import React, { useContext } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";

import { Layout } from 'antd';
import Navbar from './Navbar/Navbar';
import Home from './Home';
import Detail from './Detail/Detail'
import Movies from './Movies/Movies';
import Games from './Games/Games';
import Login from './Login/Login';
import Register from './Register/Register';
import Admin from './Admin/Admin'
import CreateForm from './Form/CreateForm'
import { UserContext } from './UserContext';
// import Detail from './Detail';

const {Footer} = Layout

const Routes = () => {
  const {user} = useContext(UserContext)

  const LoginRoute = ({...rest}) => {
    if (user) {
      return <Redirect to="/" />
    } else {
      return <Route {...rest} />
    }
  }

  const PrivateRoute = ({...rest}) => {
    if (user) {
      return <Route {...rest} />
    } else {
      return <Redirect to="/login" />
    }
  }

  return (
    <>
      <Layout className="layout">
        <Router>
          <Navbar /> {/* <- ini Navbar */}
          <Switch>
            <Route exact path="/movies" >
              <Movies />
            </Route>
            <Route exact path="/games" >
              <Games />
            </Route>
            <Route exact path="/detail/:type/:id" >
              <Detail />
            </Route>
            <LoginRoute exact path="/login" >
              <Login />
            </LoginRoute>
            <LoginRoute exact path="/register" >
              <Register />
            </LoginRoute>
            <PrivateRoute exact path="/admin" >
              <Admin />
            </PrivateRoute>
            <PrivateRoute exact path="/create" >
              <CreateForm />
            </PrivateRoute>
            <PrivateRoute exact path="/edit/:id" >
              <CreateForm />
            </PrivateRoute>
            {/* <PrivateRoute exact path="/create/game" >
              <CreateForm />
            </PrivateRoute> */}
            {/* <PrivateRoute exact path="/edit/movie/:id" >
              <Form />
            </PrivateRoute>
            <PrivateRoute exact path="/edit/game/:id" >
              <Form />
            </PrivateRoute> */}
            
            <Route path="/" >
              <Home />
            </Route>
          </Switch>
        </Router>
        <Footer style={{ textAlign: 'center' }}>Ant Design ©2018 Created by Ant UED</Footer>
      </Layout>
    </>
  )
}

export default Routes